import React from 'react';
import styled from 'styled-components';

const SavedPalettesContainer = styled.div`
    .small-title-container {
        margin-top: 30px;
        h4 {
            font-size: 0.9rem;
            color: #000;
        }
    }
`;

const SavedPalettes = () => {
    return (
        <SavedPalettesContainer>
            <div className="small-title-container">
                <h4>Load saved palettes</h4>
            </div>
        </SavedPalettesContainer>
    );
};

export default SavedPalettes;
